import Header from './components/Header';
import Hero from './components/Hero';
import SectionUpdates from './components/SectionUpdates';
import SectionAbout from './components/SectionAbout';
import SectionMedia from './components/SectionMedia';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionIndex from './components/SectionIndex';
import SectionContact from './components/SectionContact';
import SectionComments from './components/SectionComments';
import SectionCarousel from './components/SectionCarousel';
import SectionApp from './components/SectionApp';
import SectionCards from './components/SectionCards';
import SectionFaq from './components/SectionFaq';
import SectionTopics from './components/SectionTopics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionUpdates />
        <SectionAbout />
        <SectionMedia />
        <SectionFeatures />
        <SectionRanking />
        <SectionIndex />
        <SectionContact />
        <SectionComments />
        <SectionCarousel />
        <SectionApp />
        <SectionCards />
        <SectionFaq />
        <SectionTopics />
      </main>
      <Footer />
    </div>
  );
}